import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { message } from 'antd';
import { buildPriceFormat } from '../../../_utils/format_numbers';
import { 
    findAllClientPaymentsEvent
} from '../../../_events/payments/find_payments.event';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import Chip from '@mui/material/Chip';
import { buildDateTimeStr } from '../../../_utils/date_operations';
import { Divider } from "@mui/material";

const style = {
  position: 'absolute',
  marginTop: '50px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function ClientModalPayments(props) {
    const { client } = props;
    const [open, setOpen] = React.useState(false);
    const [balance, setBalance] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [lastUpdate, setLastUpdate] = React.useState('');

    const loadClientPB = () => {
        setLoading(true);
        findAllClientPaymentsEvent(client.name)
        .then(data => {
            let list = data.list;
            setBalance(list);
            setLastUpdate(list.length > 0 ? buildDateTimeStr(list[list.length - 1].date_created) : 'Sin datos');
            setLoading(false);
        })
        .catch(err => {
            message.error(err.message);
            setLoading(false);            
        });
    }

    const handleOpen = () => {
        if(client){
            loadClientPB()
            setOpen(true);
        }        
    };

    const handleClose = () => {
        setOpen(false);
        props.closeParent();
    };

    return (
        <div>
            <Button variant='contained' size='small' onClick={handleOpen}>Ver pagos</Button>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
            <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                    <strong>
                        Pagos para:
                    </strong>
                    <span>{client ? client.name : ''}</span>
                </div>                
                <div style={{display: 'flex', flexDirection: 'row-reverse', width: '50%'}}>
                    <Button size='small' onClick={handleClose}>Cerrar</Button>
                </div>
            </div>    
            <Chip style={{marginTop: '5px', marginBottom: '5px'}} color="primary" label={`Última actualización: ${lastUpdate}`} variant="outlined" />        
            {
                loading ? (
                    <PrimaryProgress />
                ) : (
                    <>
                    {
                       balance.length === 0 ? (
                        <>No hay reporte de pagos para este cliente</>
                       ) : (
                        <div style={{width: '100%'}}>
                            <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                <div style={{width: '40%', fontSize:'10px', fontWeight: 'bold'}}>Fecha</div>
                                <div style={{width: '40%', fontSize:'10px', fontWeight: 'bold'}}>Valor</div>
                            </div>
                            <div style={{width: '100%', overflowY: 'auto', height: '500px'}}>
                            {
                                balance.map((d, key) => {
                                    let date = d.payment_date ? new Date(d.payment_date) : null;
                                    let dateRep = date ? `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}` : 'NA';
                                    return(
                                        <div key={key} style={{width: '100%'}}>
                                            <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                                <div style={{width: '40%', fontSize:'10px'}}>{dateRep}</div>
                                                <div style={{width: '40%', fontSize:'10px'}}>{buildPriceFormat(Number(d.cop_value))}</div>
                                            </div>
                                            <Divider />
                                        </div>
                                    )
                                })
                            }
                            </div>
                        </div>
                       )
                    }
                    </>
                )
            }
            </Box>
        </Modal>
        </div>
    );
}